export default __webpack_public_path__ + "static/media/icon-too-sad-face-empty.0df807a2.svg";